export default {
    svgReplacements: {
        'ADxxxx': {
            reference: 'selectedAdc.partCore',
            link: 'selectedAdc.datasheet',
            qaAttrValue: 'adc'
        },
        'ADAxxxx-x': {
            reference: 'selectedDriver.partCore',
            link: 'selectedDriver.datasheet',
            qaAttrValue: 'driver'
        },
        'ADGxxxx': {
            reference: 'selectedMux.partCore',
            link: 'selectedMux.datasheet',
            qaAttrValue: 'mux'
        },
        'rx': {
            reference: 'rext',
            calculate: (value) => value * 4,
            qaAttrValue: 'rext'
        },
        'rr': {
            reference: 'rext'
        },
        'cx': {
            reference: 'cext',
            calculate: (value) => value / 3.9,
            qaAttrValue: 'cext'
        },
        'cc': {
            reference: 'cext'
        },
        'cf': {
            reference: 'cf',
        },
        'ff': {
            reference: 'rf'
        },
        'gg': {
            reference: 'rg'
        },
        'seq_inX': {
            reference: 'seqInX'
        },
        'seq_inY': {
            reference: 'seqInY'
        }
    },

    svgHiddenGroups: [
        { key: 'RCfilterGroup', meetsRequirements: (model) => !model.filterEnabled  },
        { key: 'feedbackCaps', meetsRequirements: (model) => !model.cf || model.cf === 0 }
    ],

    svgTextElements: 'text,tspan',

    circuitConfigs: [
        'SEADC_SESource_SEAmp_Inverting',
        'SEADC_SESource_SEAmp_Follower',
        'SEADC_SESource_SEAmp_NonInverting',
        'DiffADC_SESource_SEAmp_Inverting',
        'DiffADC_SESource_SEAmp_Follower',
        'DiffADC_SESource_SEAmp_NonInverting',
        'DiffADC_SESource_DiffAmp_Inverting',
        'DiffADC_DiffSource_SEAmp_Inverting',
        'DiffADC_DiffSource_SEAmp_Follower',
        'DiffADC_DiffSource_SEAmp_Non_Inverting',
        'DiffADC_DiffSource_DiffAmp_Inverting',
        'SEADC_SESource_DiffAmp',
        'SEADC_DiffSource',
        'DiffADC_DiffAmp_SESource_NonInvertingOrFollower',
        'DiffADC_DiffSource_DiffAmp_NonInvertingOrFollower'
    ],

    circuitDefaults: {
        svg: '',
        config: '',
        message: '',
        type: '',
        secondDriver: false,
        nInvertingEnabled: true,
        inputSourceTypeError: false,
        hasInternalMux: false,
        internalMux: false
    },
}